export default function getCIKtickerMap(tickersArray, allCompanies) {
  return JSON.stringify(
    tickersArray.map((ticker, index) => ({
      ticker,
      CIK: allCompanies?.[ticker]?.CIK || `N/A${index}`,
    })),
  );
}
